'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutStack } from 'design-system/client';
import CityField from './CityField';
import CountryField from './CountryField';
import StreetField from './StreetField';
import { AddressFieldsProps } from './types';
import ZipField from './ZipField';
function AddressFields(t0) {
  const $ = _c(2);
  const {
    required
  } = t0;
  let t1;
  if ($[0] !== required) {
    t1 = <LayoutStack space="400"><StreetField required={required} /><ZipField required={required} /><CityField required={required} /><CountryField required={required} /></LayoutStack>;
    $[0] = required;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default AddressFields;